import React, { useContext, Fragment, useState } from 'react';
import { UserContext } from '../context/UserContext';
import QRCode from 'qrcode.react';
import UserInfoFlat from '../components/UserInfoFlat';
import BenefitList from '../components/BenefitList';

interface ProfilePageProps {}

const ProfilePage: React.FC<ProfilePageProps> = () => {
  const authUser = useContext(UserContext);

  return (
    <div className="ceas-max-w-7xl ceas-mx-auto sm:ceas-px-6 lg:ceas-px-8">
      <div className="ceas-bg-white ceas-mt-7 ceas-px-4 ceas-py-5 ceas-border-b ceas-border-gray-200 sm:ceas-px-6">
        {authUser && <UserInfoFlat user={authUser} />}
      </div>
      <div className="canvas-wrapper ceas-py-1 ceas-flex ceas-justify-center">
        {authUser && <QRCode value={authUser?.id?.toString()} size={350} includeMargin />}
      </div>
      <div className="ceas-px-4">
        <div className="ceas-pb-5 ceas-border-b ceas-border-gray-200">
          <h3 className="ceas-text-lg ceas-leading-6 ceas-font-medium ceas-text-gray-900">
            My Benefits
          </h3>
        </div>
        <div className="ceas-mt-10">
          <BenefitList member_level={authUser?.user_level} />
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
